import { createContext, useContext, useState, useEffect } from 'react';
import AppParamsAPI from '~/api/appParamApi';

const AppParamsContext = createContext();

export function AppParamsProvider({ children }) {
    const [appParams, setAppParams] = useState([]);

    useEffect(() => {
        AppParamsAPI.getAll().then(res => setAppParams(res.data));
    }, []);

    const getParamValueById = (paramId) => {
        const param = appParams.find(p => p.ParamId === paramId);
        return param ? param.ParamValue : "";
    };

    return (
        <AppParamsContext.Provider value={{ appParams, getParamValueById }}>
            {children}
        </AppParamsContext.Provider>
    );
}

export const useAppParams = () => useContext(AppParamsContext);
